module.exports = __webpack_public_path__ + "static/img/gpt15.152dff59.png";